import * as yup from 'yup';
import {categoriesRequiringMemo, eInternalTransferCategory} from '../response/eInternalTransferCategory';

yup.setLocale({
  mixed: {
    required: 'This is required',
  },
});

export const unrestrictedInternalTransferCreateDataValidationSchema = yup.object({
  amountCents: yup.number().nullable().required(),
  category: yup.string().nullable().required(),
  escrowFileBankAccountId: yup.string().required().nullable(),
  note: yup.string().when('category', {
    is: (category: eInternalTransferCategory) => categoriesRequiringMemo.includes(category),
    then: yup
      .string()
      .matches(
        /^[a-zA-Z0-9`'?.:,()|/_+\- ]+$/,
        "Note can contain only the following non-alphanumeric characters: +-`'?.:,()/_"
      )
      .max(138, "Note can't be longer than 138 characters")
      .nullable()
      .required(),
    otherwise: yup.string().nullable(),
  }),
  orderId: yup.string().nullable().required(),
  sourceAccount: yup
    .string()
    .nullable()
    .required()
    .test('matchAccount', 'Bank Account on the file needs to match source or destination', function (sourceAccountId) {
      // Don't use arrow functions
      const escrowFileBankAccountId = this.resolve(yup.ref('escrowFileBankAccountId'));
      const destinationAccountId = this.resolve(yup.ref('destinationAccount'));

      return escrowFileBankAccountId === destinationAccountId || escrowFileBankAccountId === sourceAccountId;
    })
    .test('dontMatch', 'Source and destination accounts need to be different', function (sourceAccountId) {
      const destinationAccountId = this.resolve(yup.ref('destinationAccount'));

      return destinationAccountId !== sourceAccountId;
    }),
  destinationAccount: yup
    .string()
    .nullable()
    .required()
    .test(
      'matchAccount',
      'Bank Account on the file needs to match source or destination',
      function (destinationAccountId) {
        // Don't use arrow functions
        const escrowFileBankAccountId = this.resolve(yup.ref('escrowFileBankAccountId'));
        const sourceAccountId = this.resolve(yup.ref('sourceAccount'));

        return escrowFileBankAccountId === destinationAccountId || escrowFileBankAccountId === sourceAccountId;
      }
    )
    .test('dontMatch', 'Source and destination accounts need to be different', function (destinationAccountId) {
      const sourceAccountId = this.resolve(yup.ref('sourceAccount'));

      return destinationAccountId !== sourceAccountId;
    }),
});

export type IUnrestrictedInternalTransferDataSchema = yup.InferType<
  typeof unrestrictedInternalTransferCreateDataValidationSchema
>;
